// extracted by mini-css-extract-plugin
module.exports = {"base":"close-button_base__FCO1E","circle":"close-button_circle__4r_fc","square":"close-button_square__g3v2M"};